'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../dist-es6/client/formatters');
const PseudoGroup=require('../../../dist-es6/client/domain/pseudoGroup');
const GroupStatisticsViewModel=require('../../../dist-es6/client/viewModels/groupStatisticsViewModel');let

HeatmapGroupViewModel=function(_GroupStatisticsViewM){_inherits(HeatmapGroupViewModel,_GroupStatisticsViewM);
function HeatmapGroupViewModel(){_classCallCheck(this,HeatmapGroupViewModel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key]}var _this=_possibleConstructorReturn(this,
_GroupStatisticsViewM.call.apply(_GroupStatisticsViewM,[this].concat(args)));

_this._colSpan=1;return _this;
}HeatmapGroupViewModel.

cloneFromGroupStatisticsViewModel=function cloneFromGroupStatisticsViewModel(groupStatisticsViewModel){
const{
_id:_id,
_name:_name,
_aggregatePersons:_aggregatePersons,
_directPersons:_directPersons,
_numTripsOnDuty:_numTripsOnDuty,
_numPersonsOnDuty:_numPersonsOnDuty,
_maxFatigueOnDuty:_maxFatigueOnDuty,
_maxLastKnownFatigue:_maxLastKnownFatigue,
_averageHoursOfSleepPerDay:_averageHoursOfSleepPerDay,
_averageFatigueOnDuty:_averageFatigueOnDuty,
_fatigueThreshold:_fatigueThreshold,
_deviationThreshold:_deviationThreshold,
_percentOverThresholdCache:_percentOverThresholdCache}=
groupStatisticsViewModel;

const vm=new HeatmapGroupViewModel(
_id,
_name,
_aggregatePersons,
_directPersons,
_numTripsOnDuty,
_numPersonsOnDuty,
_maxFatigueOnDuty,
_maxLastKnownFatigue,
_averageHoursOfSleepPerDay,
_averageFatigueOnDuty,
_fatigueThreshold,
_deviationThreshold,
_percentOverThresholdCache,!1);



vm.children=groupStatisticsViewModel.children.map(HeatmapGroupViewModel.cloneFromGroupStatisticsViewModel)||[];

return vm;
};_createClass(HeatmapGroupViewModel,[{key:'colSpan',get:function()

{
return this._colSpan;
},set:function(

colSpan){
this._colSpan=colSpan;
}},{key:'children',get:function()

{
return this._children;
},set:function(

children){
_.ensureInstanceOf(Array,children);
children.forEach(function(c){return _.ensureInstanceOf([HeatmapGroupViewModel,GroupStatisticsViewModel,PseudoGroup],c)});

this._children=children;
}}]);return HeatmapGroupViewModel}(GroupStatisticsViewModel);


module.exports=HeatmapGroupViewModel;
//# sourceMappingURL=heatmapGroupViewModel.js.map
